/* src/app/service-distributor/distributors-sponsor-owner-details/distributors-sponsor-owner-details.component.scss */
::ng-deep .col-12 {
  margin: 0;
  padding: 0px;
}
form {
  width: 672px;
}
::ng-deep h3 {
  font-size: 16px;
  color: #101828;
  font-weight: 600;
  margin: 0;
}
::ng-deep input {
  margin-top: 8px;
  margin-bottom: 4px;
}
/*# sourceMappingURL=distributors-sponsor-owner-details.component-Y6MWF2CD.css.map */
